import React, { useEffect, useState, useRef } from "react";
// import * as XLSX from "xlsx";
import './AdminPage.css';
import { useMsal } from "@azure/msal-react";
// import KeyData from "../KeyData.json";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
// import SampleExcel from '../../data/KeyStatistics-Sample.xlsx';
import axios from "axios";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import ListItemText from "@mui/material/ListItemText";
// import Alert from 'react-bootstrap/Alert';
import mailData from "../../Data/mailData.js";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff",
  },
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  border: '0.1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '5px',
  padding: 0
};

const AdminPage = () => {

  const [tech, setTech] = React.useState(["full-access"]);
  const [isTechNull, setIsTechNull] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [newUser, setNewUser] = useState("");
  const [isUserNameNull, setIsUserNameNull] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);

  let techNames = [
    "full-access",
    "DevOps",
    "Agile",
    "SRE",
    "Security",
    "IE",
    "DLF",
    "SI",
    "AO",
    "PM",
    "Tech Arch",
    "Leadership",
    "Oracle",
    "SAP",
    "Robotic Process Automation (RPA)",
    "Salesforce",
    "Testing (Quality Engineering)",
    "TechExpressway",
    "Mainframe",
    "Operations",
    "AWS Cloud",
    "Content and Commerce (CnC)",
    "Data and Analytics (DnA)",
    "EAI",
    "FED",
    "GCP Cloud",
    "Low Code Development",
    "Microsoft Azure",
    "NGPL (Next-Generation Programming Languages)",
    "Portal Development",
    "Digital Learning",
    "Java",
    "Microsoft .Net",
    "Innovate & Influence (Business Innovation and Human Skills)",
    "Strategic Initiatives and Business Interlock (SIBI)",
    "Artificial Intelligence (AI)"
  ]

  function setClosure() {
    setOpenDropdown(false);
  }

  const handleDropdownOpen = () => {
    setOpenDropdown(true);
  };

  const handleDropdownClose = () => {
    setOpenDropdown(false);
  };

  const saveAddHandle = () => {
    if (newUser == "" && tech == "") {
      setIsUserNameNull(true);
      setIsTechNull(true);
      setIsAddUserOpen(true);
      setNewUser("");
      setTech(["full-access"]);
    }
    if (newUser == "") {
      setIsUserNameNull(true);
      setIsAddUserOpen(true);
    } else if (tech == "") {
      setIsTechNull(true);
      setIsAddUserOpen(true);
    } else {
      // axios.post("http://localhost:3021/track/addAdmin", { newUser, tech })
      axios.post("https://atci.lkm.qa.accenture.com/qa-apis/track/addAdmin", { newUser, tech })
        .then((res) => {
          console.log(res, "res from post addUser")
          setAlert(true);
        })
        .catch((err) => {
          console.log(err, "error msg")
          setAlert(false);
        })
      setNewUser("");
      setTech(["full-access"]);
      handleClose();
    }

  }

  const handleTechChange = (e) => {
    console.log(e.target.value, "tech checked valuessss")
    if (
      (e.target.value.length > 1 && tech.includes("full-access")) ||
      (e.target.value.length >= 1 && !e.target.value.includes("full-access"))
    ) {
      setTech(e.target.value)
      const {
        target: { value },
      } = e;
      const techUpdated = value.filter((item, i) => item !== "full-access");
      setTech(techUpdated);
    }
    else if (tech.length >= 1 && e.target.value.includes("full-access")) {
      setTech(["full-access"]);
      setClosure();
    }

    setIsTechNull(false);
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  }

  // on change states
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);
  const [boolData, setBoolData] = useState(false);
  const [inputChange, setInputChange] = useState("");
  const [alert, setAlert] = useState();

  const [excelData, setExcelData] = useState(null);

  const [show, setShow] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const { instance } = useMsal();

  const usersList = [
    "uma.rani.battu",    
    "jeevadharani.ramanan",
    "reshmi.haridas.m",
    "ankur.e.mishra",    
    "aluru.akash",
    "arpita.m.singh",
    "h.srinivasan",
    "j.b.bhardwaj",
    "aayushi.bharti",        
    "shramika.s.ambolkar",    
    "sridhar.aluri",
    "varsha.a.tyagi"
  ];

  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      let enterpriseId = activeAccount.username.split('@')[0];
      const val = usersList.some((item) => item === enterpriseId)
        ? setShowUser(true)
        : "Byee";

      console.log(val);
    } else {
      console.log("Something Wrong.....!");
    }
  }, [activeAccount]);

  const handleAlertClose = () => {
    setAlert(undefined);
  };

  alert && setTimeout(handleAlertClose, 3000);
  (alert == false) && setTimeout(handleAlertClose, 5000);



  return (
    <>
      {console.log(tech, "techhhhhhhhhhhhhh")}
      <div className="alert-container">
        {alert && <Alert onClose={handleAlertClose} className="alert-line">Updated Successfully!!</Alert>}
        {(alert == false) && <Alert severity="error" onClose={handleAlertClose} className="alert-line">Update Failed!</Alert>
        }

        {console.log(alert, "alert in starting")}

      </div>
      {showUser && (
        <div className="admin_container">
          {/* MUI Modal  */}
          <Button onClick={handleOpen} className="admin-button1">Add User</Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal-box-container">
              <div className="modal-box-wrap">
                <h2>Add User</h2>
                {/* <hr></hr> */}
                <img src="/images/AdminPage/CloseIcon.png" onClick={handleClose} alt="close-icon" className="close-button"></img>

                {/* <form onSubmit={handleSubmit} className="modal-box-form" id='form'> */}
                <div className="enterprise-box">
                  <label>Enter Enterprise ID: </label>
                  <TextField className="textfield" id="outlined-basic" multiline variant="outlined"
                  placeholder={`Eg: ${mailData.adminPlaceholder}`}
                    error={isUserNameNull && isAddUserOpen ? true : false}
                    required={isUserNameNull && isAddUserOpen ? false : true}
                    onChange={(e) => {
                      setNewUser(e.target.value);
                      setIsUserNameNull(false);
                      if (newUser !== "") {
                        setIsUserNameNull(false);
                      }
                    }}
                    helperText={
                      isUserNameNull && isAddUserOpen
                        ? "Please enter the user name"
                        : null
                    }
                  />
                </div>
                {console.log(newUser, "newUser value onChange")}
                <div className="enterprise-box box2">
                  <label>Select Technology: </label>
                  <Select
                    multiple
                    error={isTechNull && isAddUserOpen ? true : false}
                    required={isTechNull && isAddUserOpen ? false : true}
                    // labelId="demo-simple-select-label"
                    labelId="test-select-label"
                    id="demo-simple-select"
                    value={tech}
                    // label="Age"
                    onOpen={handleDropdownOpen}
                    onClose={handleDropdownClose}
                    onChange={handleTechChange}
                    className="select-options"
                    renderValue={(selected) => selected.join(", ")}
                    helperText={
                      isTechNull && isAddUserOpen
                        ? "Please select the technology"
                        : null
                    }
                  >
                    {techNames.map((val) => (
                      <MenuItem value={val} key={val}>
                        <Checkbox
                          checked={tech.indexOf(val) > -1}
                        />
                        <ListItemText primary={val} />
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                {console.log(tech, "tech value")}
                <DialogActions
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <ColorButton
                    variant="contained"
                    className="save-button"
                    size="small"
                    sx={{ background: "#7500C0", color: "white" }}
                    autoFocus
                    onClick={saveAddHandle}
                  >
                    Submit
                  </ColorButton>
                  <ColorButton
                    variant="contained"
                    className="cancel-button"
                    size="small"
                    sx={{
                      background: "white",
                      color: "#7500C0",
                      border: "solid 1px #7500C0",
                    }}
                    autoFocus
                    onClick={handleClose}
                  >
                    Cancel
                  </ColorButton>

                </DialogActions>
                {console.log(alert, "alert after submit")}
                {/* <div className="submit-btn-container">
                    <Button
                      type="submit"
                      className="submit-btn"
                      disabled={inputChange === "" ? true : false}
                      onClick={() => setTimeout(() => {
                        setAlert(true)
                        handleClose();
                      }, 500)}
                    >
                      Publish Data
                    </Button>
                  </div> */}
                {/* </form> */}


              </div>
            </Box>
          </Modal>

        </div>
      )}
    </>
  );
};

export default AdminPage;
